import React, { useState,useEffect } from 'react';
import { Button } from 'react-bootstrap';
import {toast} from 'react-toastify';
import * as RestService from '../../services/eisRest';


import WarehouseStatusOnDateDatatable from './WarehouseStatusOnDateDatatable';
import LoadingOverlay from 'react-loading-overlay';
import {useTranslation} from 'react-i18next';
import sk from 'date-fns/locale/sk';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
registerLocale('sk', sk)



const WarehouseStatusOnDateTab = (props) => {

    const [t] = useTranslation();      
    const [show , setShow]= useState( false );
    const [recordId, setRecordId ] = useState();    
    const [transactionFrom, setTransactionFrom]  = useState(Date.now());
    const [transactionTo, setTransactionTo]  = useState(Date.now());
    const [preparing, setPreparing]  = useState(false);
    

    const handleCallback = (id) => {
          setRecordId(id);       
        
    };
 
 
    useEffect(() => {      
      setRecordId(props.selectedRecord);
    }, [props.selectedRecord])
  
    const prepareDataHandle = () => {

      setPreparing(true);
      let recordIdTemp = recordId;
      setRecordId('');      
      RestService.callAnyApi('warehouse/fillWarehouseStatusOnDate?warehouseId='+recordIdTemp+'&dateFrom='+transactionFrom+'&dateTo='+transactionTo, null)
      .then((data) => {          
           setPreparing(false);
           if(data) {
             toast.success(t('general.message.dataPrepared'));    
           }else{
             toast.error(t('general.message.failed'));
           }
           setRecordId(recordIdTemp);   
           
      })
      .catch((error) => {
        console.log(error);
        setPreparing(false);
        toast.error(t('general.message.failed'));
        setRecordId(recordIdTemp); 
      });

    }

    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
         <LoadingOverlay
            active={preparing}
            spinner
            text={t('general.message.preparingData')}
        >
          <div  style={{display: 'inline-block'}}>
                  <div style={{marginLeft:'20px'}}>
                          <div className="form-group">
                  								
                                  <label style={{marginRight:'4px'}}>{t('warehouse.label.transactionFrom')}: </label>                                 
                                  <DatePicker
                                        className='form-control'                                       
                                        selected={transactionFrom}
                                        onChange={(value) => setTransactionFrom(new Date(value).getTime())}
                                        dateFormat="dd.MM.yyyy"                                                                              
                                  />                                   
                        
                                  <span style={{marginLeft: '10px'}}> 
                                      <label style={{marginRight:'4px'}}>{t('warehouse.label.transactionTo')}: </label>                                 
                                      <DatePicker
                                            className='form-control'                                       
                                            selected={transactionTo}
                                            onChange={(value) => setTransactionTo(new Date(value).getTime())}
                                            dateFormat="dd.MM.yyyy"                                                                              
                                      />    
                                  </span>                               

                                  <span style={{marginLeft: '10px'}}> 
                                      <Button className="btn-primary" onClick={prepareDataHandle}>{t('general.button.prepareData')}</Button>    
                                  </span>              
                          </div> 
                    </div>

          </div>

          <WarehouseStatusOnDateDatatable            
            parentCallback={handleCallback}    
            warehouseId={recordId}                           
          />
              </LoadingOverlay>   
        </div>
    );
};

export default WarehouseStatusOnDateTab;